import React from 'react';
import { IElementListItem } from '../api';
import { getMediaSessionStatusInfo, getSessionTypeName, getSubmissionTimeTips } from '../transofrm';
import { LeftIcon } from './leftIcon';
import _get from 'lodash/get';
import _compact from 'lodash/compact';
import { lang } from '@umu/ukit-lang';
import { getBool } from '../util';
import { components } from 'common';
import { Button } from '@umu/umu-design';
const { If } = components;

interface IProps {
    item: IElementListItem;
    courseInfo?: any;
}
export const SessionCard = (props: IProps) => {
    const { item, courseInfo } = props;
    const text = item.setup.type_name || getSessionTypeName(item);
    const showIndex = getBool(_get(courseInfo, 'setup.show_session_index', 1));
    const { label, styleType } = getMediaSessionStatusInfo(item);
    const {
        index,
        title,
        is_require,
        share_url,
        extend: { lock },
    } = item;
    const submissionTime = getSubmissionTimeTips(item);
    const statStr = _compact([text, !is_require && lang('选修')]).join(' · ');
    const isLocked = getBool(lock);
    return (
        <div
            className="card session-card"
            onClick={() => {
                if (isLocked) {
                    return;
                }
                window.location.href = share_url;
            }}
        >
            <LeftIcon item={item}></LeftIcon>
            <div className={getBool(lock) ? 'session-locked' : ''}>
                <div className="title text-truncate-2">
                    {showIndex ? index + '. ' : ''}
                    <i className={`icon iconfont icon-course-type icon-course-type-${item.type}`}></i>
                    <span className="session-card__type-name" dangerouslySetInnerHTML={{
                        __html: statStr,
                    }}/>
                    <span className="session-card--name">{title}</span>
                </div>
                <div className="session-card-status">
                    <If condition={!!label}>
                        <Button className="session-card-status--label" type={styleType === 1 ? 'primary' : 'ghost-grey'}>
                            {label}
                        </Button>
                    </If>
                    <If condition={!!submissionTime}>
                        <Button className="session-card-status--time" type="ghost-grey">
                            {submissionTime}
                        </Button>
                    </If>
                </div>
            </div>
        </div>
    );
};
